import Browser from '@mindful-web/marko-web/browser';
import Daily from '@ascend-media/package-daily/browser';

Daily(Browser);

export default Browser;
